import React, { useContext, useEffect, useState, useRef } from "react";
import { Button, ButtonGroup, Container, Row, Col } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { reducer } from "../../../../../../context";
import actionType from "../../../../../../context/actionType";
import { AssetArea, AssetType } from "../../../../../../enum";
import {
  SwitchLabel,
  SwitchView,
  TopBar,
  TopBarContainer,
  ButtonGroupContainer,
} from "../../AssetListScreenStyles";
import Switch from "react-switch";
import { AssetsListTopBarPagination } from "./Sections/Pagination";
import PriceSlider from "../PriceSlider";
import { useTranslation } from "react-i18next";

interface Props {
  isMobile?: boolean;
}

// Contains filters for asset list query
const AssetListHeader: React.FunctionComponent<Props> = (props) => {
  const { t, i18n } = useTranslation();
  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";
  const { assetsReducer, googleMapReducer } = useContext(reducer);
  const { filter } = assetsReducer.state;
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(50000);
  // const [isInputBarOpen, setIsInputBarOpen] = useState(false);
  // const [isInputBarMin, setIsInputBarMin] = useState(true);
  const [isShowOthers, setIsShowOthers] = useState(false);
  const [showSlider, setShowSlider] = useState(false);
  const assetAreaList = [
    { t: "woodland", filterValue: AssetArea.woodland },
    { t: "seaside", filterValue: AssetArea.seaside },
    // { t: 'urbanForest', filterValue: AssetArea.urbanForest },
    // { t: 'orchard', filterValue: AssetArea.orchard },
  ];
  const assetTypeList = [AssetType.tree, AssetType.bench, AssetType.seat];
  const changeFilter = (filterType: "type" | "area") => (value: any) => {
    let temp = Object.assign({}, assetsReducer.state.filter);
    if (temp[filterType] === value) {
      temp[filterType] = undefined;
    } else {
      temp[filterType] = value;
    }
    assetsReducer.dispatch({
      type: actionType.assets.ASSET_EDIT_FILTER,
      payload: {
        filter: temp,
      },
    });
  };
  const handleAreaFilterClick = (area: AssetArea) => changeFilter("area")(area);
  const handleTypeFilterClick = (type: AssetType) => changeFilter("type")(type);
  useEffect(() => {
    assetsReducer.dispatch({
      type: actionType.assets.ASSET_EDIT_FILTER,
      payload: {
        filter: {
          price: {
            min: minPrice,
            max: maxPrice,
          },
        },
      },
    });
    // }
  }, [minPrice, maxPrice]);
  useEffect(() => {
    if (filter && filter.price) {
      setMaxPrice(filter.price.max);
      setMinPrice(filter.price.min);
    }
  }, [filter && filter.price]);
  const onToggleOtherDonorSwitch = () => {
    const showDonors = !isShowOthers;
    setIsShowOthers(showDonors);
    assetsReducer.dispatch({
      type: actionType.assets.SET_SHOW_OTHER_DONORS,
      payload: {
        showDonors,
      },
    });
  };
  const resetFilter = () => {
    assetsReducer.dispatch({
      type: actionType.assets.ASSET_RESET_FILTER,
      payload: {},
    });
    googleMapReducer.dispatch({
      type: actionType.googleMap.GOOGLE_MAP_RESET_MAP_BOUNDS,
      payload: {},
    });
  };

  const removeDefaultMarginStyles = isMobile ? { padding: 0, margin: 0 } : {};
  return (
    <TopBar isMobile={isMobile}>
      <Container style={{ maxWidth: "100%" }}>
        <Row>
          <Col style={removeDefaultMarginStyles}>
            <TopBarContainer isMobile={isMobile}>
              <Button
                onClick={() => setShowSlider(!showSlider)}
                variant={"primary"}
                style={{
                  fontFamily: useChinese ? "Microsoft Jhenghei" : "Rambla",
                  borderColor: "#FFFFFF",
                  ...(filter && filter.price
                    ? { backgroundColor: "#2c3c4e" }
                    : { backgroundColor: "#2c3c4e" }),
                }}
              >
                {t("filter.price")}
              </Button>
              <PriceSlider
                isVisible={showSlider}
                onChange={(price) => {
                  setMinPrice(price[0]);
                  setMaxPrice(price[1]);
                  setShowSlider(false);
                }}
                currentValues={[minPrice, maxPrice]}
              />
              <ButtonGroupContainer isMobile={isMobile}>
                <ButtonGroup aria-label="Basic example">
                  {assetAreaList.map((n, i) => (
                    <Button
                      onClick={() => handleAreaFilterClick(n.filterValue)}
                      key={i}
                      style={{
                        fontFamily: useChinese
                          ? "Microsoft Jhenghei"
                          : "Rambla",
                        borderColor: "#FFFFFF",
                        ...(filter && filter.area === n.filterValue
                          ? {}
                          : { backgroundColor: "#2c3c4e" }),
                      }}
                      variant={
                        filter && filter.area === n.filterValue
                          ? "primary"
                          : "secondary"
                      }
                    >
                      {t(`filter.${n.t}`)}
                    </Button>
                  ))}
                </ButtonGroup>
                <ButtonGroup
                  aria-label="Basic example"
                  style={{ marginLeft: isMobile ? 0 : 13 }}
                >
                  {assetTypeList.map((n, i) => (
                    <Button
                      onClick={() => handleTypeFilterClick(n)}
                      key={i}
                      style={{
                        fontFamily: useChinese
                          ? "Microsoft Jhenghei"
                          : "Rambla",
                        borderColor: "#FFFFFF",
                        ...(filter && filter.type === n
                          ? {}
                          : { backgroundColor: "#2c3c4e" }),
                      }}
                      variant={
                        filter && filter.type === n ? "primary" : "secondary"
                      }
                    >
                      {t(`filter.${n.toLocaleLowerCase()}`)}
                    </Button>
                  ))}
                </ButtonGroup>
                <Button
                  onClick={() => resetFilter()}
                  variant={"primary"}
                  style={{
                    fontFamily: useChinese ? "Microsoft Jhenghei" : "Rambla",
                    color: "#2c3c4e",
                    borderColor: "#2c3c4e",
                    backgroundColor: "transparent",
                    ...(isMobile ? { marginBottom: 12 } : { marginLeft: 16 }),
                  }}
                >
                  {t("filter.reset")}
                </Button>
              </ButtonGroupContainer>

              <SwitchView>
                <SwitchLabel useChinese={useChinese}>
                  {t("filter.showDonorsNearby")}
                </SwitchLabel>
                <Switch
                  onChange={onToggleOtherDonorSwitch}
                  checked={isShowOthers}
                  height={36}
                  width={66}
                  onColor={"#2c3c4e"}
                  uncheckedIcon={false}
                  checkedIcon={false}
                />
              </SwitchView>
            </TopBarContainer>
          </Col>
        </Row>
      </Container>
    </TopBar>
  );
};

export default AssetListHeader;
